module.exports = __webpack_public_path__ + "img/pointer_02.1778c23b.png";